import React, {useEffect} from 'react';
import BasicLayout from './layout/BasicLayout/BasicLayout';
import Home from './pages/Home/Home';
import Company from './pages/Company/Company';

import {useController} from "./App.controller";
import SoftwareProduct from "./pages/SoftwareProduct/SoftwareProduct";
import HomeOutlined from "@ant-design/icons/es/icons/HomeOutlined";
import CreateUpdateCompanyDialog from "./pages/CreateUpdateCompanyDialog/CreateUpdateCompanyDialog";
import SoftwareProductElement from "./pages/SoftwareProductElement/SoftwareProductElement";
import ExpiryLicenceAction from "./pages/ExpiryLicenceAction/ExpiryLicenceAction";
import Licence from "./pages/Licence/Licence";
import Dashboard from "./pages/Dashboard/Dashboard";
import CreateUpdateLicenceDialog from "./pages/CreateUpdateLicenceDialog/CreateUpdateLicenceDialog";

const pages = [
    {
        key: 'home',
        component: Home
    },
    {
        key: 'company',
        component: Company
    },
    {
        key: 'addCompany',
        component: CreateUpdateCompanyDialog
    },
    {
        key: 'editCompany/:id',
        component: CreateUpdateCompanyDialog
    },
    {
        key: 'licence',
        component: Licence
    },
    {
        key: 'addLicence',
        component: CreateUpdateLicenceDialog
    },
    {
        key: 'dashboard',
        component: Dashboard
    },
    {
        key: 'softwareProduct',
        component: SoftwareProduct
    },
    {
        key: 'softwareProductElement',
        component: SoftwareProductElement
    },
    {
        key: 'expiryLicenceAction',
        component: ExpiryLicenceAction
    }
];

const menuItems = [
    {
        key: 'dashboard',
        value: 'Dashboard',
        icon: 'RadarChartOutlined',
        rules: {}
    },
    {
        key: 'company',
        value: 'Companies',
        icon: 'GlobalOutlined',
        rules: {}
    },
    {
        key: 'licence',
        value: 'Licences',
        icon: 'CopyrightOutlined',
        rules: {}
    },
    {
        key: 'home',
        value: 'Početna',
        icon: 'HomeOutlined',
        rules: {},
        hideFromMenu: true
    },
    {
        key: 'addCompany',
        value: 'Add Company',
        icon: 'GlobalOutlined',
        rules: {},
        hideFromMenu: true
    },
    {
        key: 'editCompany/:id',
        value: 'Edit Company',
        icon: 'GlobalOutlined',
        rules: {},
        hideFromMenu: true
    },
    {
        key: 'addLicence',
        value: 'Add Licence',
        icon: 'CopyrightOutlined',
        rules: {},
        hideFromMenu: true
    },
    {
        divider: true,
        value: 'Codebooks'
    },
    {
        key: 'softwareProduct',
        value: 'Software Products',
        icon: 'LaptopOutlined',
        rules: {}
    },
    {
        key: 'softwareProductElement',
        value: 'SW Product Elements',
        icon: 'ApiOutlined',
        rules: {}
    },
    {
        key: 'expiryLicenceAction',
        value: 'Expiry Licence Actions',
        icon: 'FieldTimeOutlined',
        rules: {}
    }];

const applicationName = "Via Planet Licence Manager";

const App = () => {
    const {user, userData, dropdownItems, darkMode, theme, primaryColor, refreshThemeSettings, isExtraSmall} = useController();
    const authenticated = !!user;

    useEffect(() => {
        refreshThemeSettings();
    }, []);

    return (
        <BasicLayout
            applicationName={applicationName}
            menuItems={menuItems}
            customItems={[]}
            pages={pages}
            dropdownItems={dropdownItems}
            theme={theme}
            darkMode={darkMode}
            isExtraSmall={isExtraSmall}
            primaryColor={primaryColor}
            user={user}
            userData={userData}
            authenticated={authenticated}
        />
    );
};

export default App;
